/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { FragmentMarketCountry } from '@gql/FragmentMarketCountry'
import { PublicMarketCountryMultiget } from '@gql/PublicMarketCountryMultiget'

export function useCountriesMultiget(getId: () => { iso2: string | None } | None) {
  const valueHolder = shallowRef<gen.MarketCountryFragment | undefined>()

  const { recheck } = useMultigetDebouceGet<
    gen.MarketCountryFragment,
    gen.PublicMarketCountryMultigetQuery,
    gen.PublicMarketCountryMultigetQueryVariables
  >({
    uniqueName: 'useCountriesMultiget',
    checkId: () => ({ id: getId()?.iso2 }),
    fragment: FragmentMarketCountry,
    fragmentName: 'MarketCountry',
    query: PublicMarketCountryMultiget,
    vars: (iso2) => ({ iso2 }),
    on(doc) {
      valueHolder.value = doc
    },
  })

  watch(
    () => getId()?.iso2,
    (iso2, prev) => {
      if (iso2 === prev || !iso2 || valueHolder.value?.iso2 === iso2) return
      recheck()
    },
  )

  return { country: toRef(() => valueHolder.value), recheck }
}
